import { TranslocoService } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { KpiWidgetComponent } from '../../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { BaseWidgetComponent } from '../../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../../_shared/services';
import { ServiceLibraryService } from '../../../services/service-library.service';
import { ErrorHandlerService } from '../../../../../../_shared/services/error-handler.service';
import { AccountFilterRequest } from '../../../../../../_shared/models/account-filter.model';

@Component({
  selector: 'app-makes',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './makes.component.html',
  styleUrl: './makes.component.scss'
})
export class MakesComponent extends BaseWidgetComponent {
  private readonly transloco = inject(TranslocoService);
  private readonly serviceLibraryService: ServiceLibraryService = inject(ServiceLibraryService);
  private errorHandlerService = inject(ErrorHandlerService);

  hasError: boolean = false;
  errorMessage: string = '';

  constructor() {
    const filterService: FilterService = inject(FilterService);
    super(filterService);
    this.title = this.transloco.translate('serviceLibrary.widgets.makes');
    this.isLoading = true;
    this.value = 0;
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    await this.getVehiclemakesAsync();
  }

  public override formatValue(value: number): string {
    return `${value}`;
  }

  async getVehiclemakesAsync() {
    try {
      this.isLoading = true;
      this.cancelSubject.next();

      const request: AccountFilterRequest = {
        accountIds: this.widgetFilter.accountIds
      }

      const response = await this.serviceLibraryService.getVehicleMakesStatsKpi(request, this.cancelSubject);
      this.value = response.data ?? 0;
      this.isLoading = false;
    } catch (error) {
      this.errorHandlerService.handleError(error, {
				callback: (message) => {
					this.errorMessage = message;
					this.hasError = true;
					this.isLoading = false;
				}
			});
    }
  }
}